import actions from './actions'

const proxy = {
  state: null,
  mutations: null,
  actions
}

export default proxy



// WEBPACK FOOTER //
// ./src/store/proxy/index.js